export const paginationLocale = {
    ellipsis: '…',
    previous: 'Previous',
    next: 'Next',
    ariaLabel: 'Pagination',
    ariaGoToPrevious: 'Previous page',
    ariaGoToNext: 'Next page',
    ariaCurrentPage: (page) => `Page ${page}, current page`,
    ariaGoToPage: (page) => `Page ${page}`,
};
//# sourceMappingURL=Pagination.locale.mjs.mjs.map